<script setup lang="ts">
import type { AppButtonEmits } from './types/app-button-events'
import type { AppButtonProps } from './types/app-button-props'

const props = withDefaults(defineProps<AppButtonProps>(), {
  type: 'button'
})

const emit = defineEmits<AppButtonEmits>()

const formatClass = computed(() => {
  return [props.class, { disabled: props.disabled }]
})
</script>

<template>
  <button
    :id="props.id"
    :aria-label="props['aria-label']"
    :class="formatClass"
    :disabled="props.disabled"
    :type="props.type"
    @click="emit('click', $event)"
    @keydown="emit('keydown', $event)"
  >
    <slot></slot>
  </button>
</template>
